import React, {FC, useEffect, useState} from "react";
import TickManager from "../service/TickManager";
import {Charges, Option} from "../models/SGB";
import GatewayService from "../service/GatewayService";
import AppConstants from "../util/AppConstants";

const TestComponent: FC = () => {
    const [buyOption, setBuyOption] = useState<Option|null>();
    const [sellOption, setSellOption] = useState<Option|null>();
    const [charges, setCharges] = useState<Charges|undefined>()
    const [buyStrike, setBuyStrike] = useState(100000);
    const [sellStrike, setSellStrike] = useState(100100);
    const [goldPrice, setGoldPrice] = useState(121380);
    const [totalMargin, setTotalMargin] = useState<number | null>(null);

    function reverse(){
        let buy = sellStrike
        let sell = buyStrike
        setBuyStrike(buy)
        setSellStrike(sell)
    }

    useEffect(()=>{
    }, [buyStrike, sellStrike, goldPrice])
    const fetchMargin = async () => {
        try {
            const response = await fetch('https://margin-calc-arom-prod.angelbroking.com/margin-calculator/SPAN', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    position: [
                        {
                            contract: "GOLD-26NOV25",
                            exchange: "MCX",
                            product: "OPTION",
                            qty: 1,
                            strikePrice: (sellStrike),
                            tradeType: "SELL",
                            optionType: "CALL"
                        },
                        {
                            contract: "GOLD-26NOV25",
                            exchange: "MCX",
                            product: "OPTION",
                            qty: 1,
                            strikePrice: (buyStrike),
                            tradeType: "BUY",
                            optionType: "CALL"
                        }
                    ]
                })
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            if (data && data.margin && typeof data.margin.totalMargin !== 'undefined') {
                setTotalMargin(data.margin.totalMargin);
            } else {
                console.error("Invalid response structure", data);
                setTotalMargin(null);
            }
            setBuyOption(TickManager.getOption(`GOLD25NOV${buyStrike}CE`))
            setSellOption(TickManager.getOption(`GOLD25NOV${sellStrike}CE`))
            GatewayService.getMarginBySymbols({buyCall : buyOption!!.genInfo.tradingsymbol, sellCall : sellOption!!.genInfo.tradingsymbol, type : AppConstants.ComboType.buyCallSellCall})
                .then(setCharges)
        } catch (error) {
            console.error("Failed to fetch margin:", error);
            setTotalMargin(null);
        }
    };

    const strikeDiff = Number(sellStrike) - Number(goldPrice);

    function increase() {
        setBuyStrike((buyStrike)+1000)
        setSellStrike((sellStrike)+1000)
    }

    return (
        <div>
            <h1>Gold Option Margin Calculator</h1>
            <div>
                <label>
                    Buy Strike:
                    <input type="text" value={buyStrike} onChange={e => setBuyStrike(parseInt(e.target.value))}/><button onClick={()=>increase()}>+</button>
                </label>
            </div>
            <div>
                <label>
                    Sell Strike:
                    <input type="text" value={sellStrike} onChange={e => setSellStrike(parseInt(e.target.value))}/>
                </label>
            </div>
            <div>
                <label>
                    Gold Current Price:
                    <input type="text" value={goldPrice} onChange={e => setGoldPrice(parseInt(e.target.value))}/>
                </label>
            </div>
            <button onClick={fetchMargin}>Fetch Margin Requirements</button>
            <button onClick={reverse}>Reverse</button>

            {totalMargin !== null && (
                <div>
                    <h2>Margin Details {buyOption?.genInfo.tradingsymbol}, {sellOption?.genInfo.tradingsymbol}</h2>
                    <p>Total Margin: {totalMargin}</p>
                </div>
            )}

            {charges !== null && (
                <div>
                    <h2>From Zerodha</h2>
                    <p>{JSON.stringify(charges)}</p>
                </div>
            )}

            <div>
                <h2>Strike Difference</h2>
                <p>Sell Strike - Gold Price: {strikeDiff*100}</p>
            </div>

            {/*<div>*/}
            {/*    <h2>Margin diff</h2>*/}
            {/*    <p>Sell Strike - Gold Price: {strikeDiff*100}</p>*/}
            {/*</div>*/}
        </div>
    );
};

export default TestComponent;
